import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOrderConfig } from "PFCore/services/saas_admin/order_config";
import { Id } from "PFTypes";
import { OrderConfig } from "PFTypes/order_config";
import { MutationOptions } from "PFTypes/request_options";

import { orderConfigKeys } from "./query_keys";

export const useOrderConfigUpdate = (
  accountId: Id,
  target: string,
  { onSuccess, ...options }: MutationOptions<OrderConfig> = {}
) => {
  const cache = useQueryClient();

  return useMutation({
    mutationFn: (payload: OrderConfig) => updateOrderConfig(accountId, target, payload),
    onSuccess: (data: OrderConfig, ...params) => {
      cache.invalidateQueries(orderConfigKeys.target(accountId, target));
      onSuccess?.(data, ...params);
    },
    ...options
  });
};
